module.exports = __webpack_public_path__ + "img/scrmNum1.c07da12f.png";